// extracted by mini-css-extract-plugin
module.exports = {"clientVoice":"HomeVoice_clientVoice__OWDFO"};